<template id="modal-template">
    <transition name="modal" appear v-if="modal">
        <div class="modal-container">
            <div class="modal-wrapper">
                <div class="modal modal--flat modal--12">
                    <div class="modal__head">
                        <button class="modal__close" type="button" @click="modal = false;">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15.6 15.6" style="enable-background:new 0 0 15.6 15.6;" xml:space="preserve">
                                <g style="fill:#ffffff">
                                    <path d="M0,1.4L1.4,0l14.1,14.1l-1.4,1.4L0,1.4z"/>
                                    <path d="M14.1,0l1.4,1.4L1.4,15.6L0,14.1L14.1,0z"/>
                                </g>
                            </svg>
                        </button>
                        <h1 class="modal__title">새집처럼 투명 견적서</h1>
                    </div>
                    <div class="modal__body">
                        <div class="estimate-container">
                            <section class="estimate-section" v-if="portfolio.estimate.type == 'data1'">
                                <h2 class="title">견적정보</h2>

                                <div v-if="portfolio.construction" class="estimate-table estimate-table--horizontal">
                                    <div class="tr">
                                        <div class="th">견적일자</div>
                                        <div class="td">{{ portfolio.construction.estimatedDate.toDate() }} </div>
                                        <div class="th">계약업체</div>
                                        <div class="td">{{ portfolio.user.meta.companyName }}</div>
                                        <!-- <div class="th">접수번호</div>
                                        <div class="td">{{ portfolio._id }}</div> -->
                                    </div>
                                    <div class="tr">
                                        <div class="th">공사명</div>
                                        <div class="td">{{ portfolio.subject }}</div>
                                        <div class="th">대표자</div>
                                        <div class="td">{{ portfolio.user.name }}</div>
                                    </div>
                                    <div class="tr">
                                        <div class="th">시공면적</div>
                                        <div class="td">{{ portfolio.construction.acreage.format()}} 평대</div>
                                        <div class="th">사업자번호</div>
                                        <div class="td">{{ portfolio.user.meta.businessNumber }}</div>
                                        <!-- <div class="th">고객이름</div>
                                        <div class="td">{{ portfolio.contract.clientName }}</div> -->
                                    </div>
                                    <div class="tr">
                                        <div class="th">시공지역</div>
                                        <div class="td">{{ portfolio.construction.address }}</div>
                                        <div class="th">업체주소</div>
                                        <div class="td">{{ `${portfolio.user.address1} ${portfolio.user.address2}` }}</div>
                                    </div>
                                    <div class="tr">
                                        
                                        <!-- <div class="th">전화번호</div>
                                        <div class="td">{{portfolio.user.phone}}</div> -->
                                    </div>
                                    <!-- <div class="tr">
                                        <div class="th">팩스</div>
                                        <div class="td">기획자한태 물어봐야함</div>
                                    </div> -->
                                </div>

                                <div class="estimate-table estimate-table--bottom">
                                    <div class="tr">
                                        <div class="th"><b>총금액{{ portfolio.estimate.vatEnable ? "(부가세포함)" : "(부가세별도)" }}</b></div>
                                        <div class="td"><b>{{ totalAmount.format() }} 원</b></div>
                                    </div>
                                </div>

                                <div class="mobile-scroll-container">
                                    <div class="mobile-scroll-wrapper">
                                        <div class="mobile-scroll-inner">
                                            <div class="estimate-table estimate-table--vertical">
                                                <div class="tr">
                                                    <div class="th" style="width:6%">번호</div>
                                                    <div class="th" style="width:10%">내역</div>
                                                    <div class="th" style="width:30%">규격</div>
                                                    <div class="th">수량</div>
                                                    <div class="th">단위</div>
                                                    <div class="th">단가</div>
                                                    <div v-if="discountEnabled" class="th">할인단가</div>
                                                    <div class="th">금액</div>
                                                    <div class="th" style="width:15%">비고</div>
                                                </div>
                                                <div v-for="(row, index) in portfolio.estimate.data1" :key="index" class="tr">
                                                    <div class="td"> {{ row.no }}</div>
                                                    <div class="td"> {{ row.description }}</div>
                                                    <div class="td"> {{ row.size }}</div>
                                                    <div class="td"> {{ row.quantity ? (+row.quantity).format() : '' }}</div>
                                                    <div class="td"> {{ row.unit }}</div>
                                                    <div class="td"> {{ row.unitPrice ? (+row.unitPrice).format() : '' }}</div>
                                                    <div v-if="discountEnabled" class="td"> {{ row.discountPrice ? (+row.discountPrice).format() : '' }}</div>
                                                    <div v-if="!discountEnabled" class="td"> {{ row.amount ? (+row.amount).format() : '' }} 원</div>
                                                    <div v-else class="td"> {{ row.discountAmount ? (+row.discountAmount).format() : '' }} 원</div>
                                                    <div class="td"> {{ row.remark }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="estimate-table estimate-table--bottom">
                                    <div class="tr">
                                        <div class="th">공급가</div>
                                        <div class="td">{{ supplyAmount.format() }} 원</div>
                                    </div>
                                    <div v-if="portfolio.estimate.vatEnable" class="tr">
                                        <div class="th">부가세</div>
                                        <div class="td">{{ vat.format() }} 원</div>
                                    </div>
                                    <div class="tr">
                                        <div class="th"><b>총금액</b></div>
                                        <div class="td"><b>{{ totalAmount.format() }} 원</b></div>
                                    </div>
                                </div>
                            </section>
                            <section v-if="portfolio.estimate.type == 'data2'">
                                <ul class="tab-contents">
                                    <transition>
                                    <!-- 상세견적 -->
                                    <li class="on">
                                        <section class="estimate-section" v-if="portfolio.estimate.type == 'data2'">
                                            <h2 class="title">견적정보</h2>

                                            <div v-if="portfolio.construction" class="estimate-table estimate-table--horizontal">
                                                <div class="tr">
                                                    <div class="th">견적일자</div>
                                                    <div class="td">{{ portfolio.construction.estimatedDate.toDate() }} </div>
                                                    <div class="th">계약업체</div>
                                                    <div class="td">{{ portfolio.user.meta.companyName }}</div>
                                                    <!-- <div class="th">접수번호</div>
                                                    <div class="td">{{ portfolio._id }}</div> -->
                                                </div>
                                                <div class="tr">
                                                    <div class="th">공사명</div>
                                                    <div class="td">{{ portfolio.subject }}</div>
                                                    <div class="th">대표자</div>
                                                    <div class="td">{{ portfolio.user.name }}</div>
                                                </div>
                                                <div class="tr">
                                                    <div class="th">시공면적</div>
                                                    <div class="td">{{ portfolio.construction.acreage.format()}} 평대</div>
                                                    <div class="th">사업자번호</div>
                                                    <div class="td">{{ portfolio.user.meta.businessNumber }}</div>
                                                    <!-- <div class="th">고객이름</div>
                                                    <div class="td">{{ portfolio.contract.clientName }}</div> -->
                                                </div>
                                                <div class="tr">
                                                    <div class="th">시공지역</div>
                                                    <div class="td">{{ portfolio.construction.address }}</div>
                                                    <div class="th">업체주소</div>
                                                    <div class="td">{{ `${portfolio.user.address1} ${portfolio.user.address2}` }}</div>
                                                </div>
                                                <div class="tr">
                                                    
                                                    <!-- <div class="th">전화번호</div>
                                                    <div class="td">{{portfolio.user.phone}}</div> -->
                                                </div>
                                                <!-- <div class="tr">
                                                    <div class="th">팩스</div>
                                                    <div class="td">기획자한태 물어봐야함</div>
                                                </div> -->
                                            </div>

                                            <div class="estimate-table estimate-table--bottom">
                                                <div class="tr">
                                                    <div class="th"><b>총금액{{ portfolio.estimate.vatEnable ? "(부가세포함)" : "(부가세별도)" }}</b></div>
                                                    <div class="td"><b>{{ totalAmount.format() }} 원</b></div>
                                                </div>
                                            </div>                                                 
                                        </section>
                                        <section class="estimate-section">
                                            <div class="mobile-scroll-container">
                                                <div class="mobile-scroll-wrapper">
                                                    <div class="mobile-scroll-inner">
                                                        <span class="etable-border"></span>
                                                        <table class="etable">
                                                            <tbody>
                                                                <tr>
                                                                    <th rowspan="9999">자재</th>
                                                                    <th>위치</th>
                                                                    <td class="bg-grey">항목</td>
                                                                    <td class="bg-grey">제조원</td>
                                                                    <td class="bg-grey">품명</td>
                                                                    <td class="bg-grey">사이즈</td>
                                                                    <td class="bg-grey">단가</td>
                                                                    <td v-if="discountEnabled" class="bg-grey">할인단가</td>
                                                                    <td class="bg-grey">수량</td>
                                                                    <td class="bg-grey">합계</td>
                                                                    <td class="bg-grey">비고</td>
                                                                </tr>
                                                                <tr v-for="(space, index) in portfolio.estimate.data2.material.spaces" :key="index">
                                                                    <td :colspan="discountEnabled ? 10 : 9">
                                                                        <table>
                                                                            <tbody>
                                                                                <tr v-for="(row, index) in space.rows" :key="index">
                                                                                    <th :rowspan="space.rows.length" :style="{ display: index ? 'none' : 'init' }">{{ space.name }}</th>
                                                                                    <td>{{ row.item }}</td>
                                                                                    <td>{{ row.manufacturer }}</td>
                                                                                    <td>{{ row.productName }}</td>
                                                                                    <td>{{ row.size }}</td>
                                                                                    <td>{{ row.unitPrice ? (+row.unitPrice).format() : '' }}</td>
                                                                                    <td v-if="discountEnabled">{{ row.discountPrice ? (+row.discountPrice).format() : '' }}</td>
                                                                                    <td>{{ row.quantity ? (+row.quantity).format() : '' }}</td>
                                                                                    <td v-if="!discountEnabled">{{ row.amount ? (+row.amount).format() : '' }}</td>
                                                                                    <td v-else>{{ row.discountAmount ? (+row.discountAmount).format() : '' }}</td>
                                                                                    <td>{{ row.remark }}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th colspan="2" class="bg">소계</th>
                                                                    <td :colspan="discountEnabled ? 6 : 5" class="bg-light"></td>
                                                                    <td colspan="3" class="bg-light">
                                                                        <div><b>공급가격: {{ material.supplyAmount.format() }} 원</b></div>
                                                                        <div v-if="discountEnabled"><b>할인가격: {{ material.discountAmount.format() }} 원 ({{ 100 - Math.floor(material.discountAmount / material.supplyAmount * 100) || 0 }}%)</b></div>
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mobile-scroll-container">
                                                <div class="mobile-scroll-wrapper">
                                                    <div class="mobile-scroll-inner">
                                                        <table class="etable">
                                                            <tbody>
                                                                <tr>
                                                                    <th rowspan="9999">인건비</th>
                                                                    <th>구분</th>
                                                                    <td class="bg-grey">등급</td>
                                                                    <td class="bg-grey">인원</td>
                                                                    <td class="bg-grey">성명</td>
                                                                    <td class="bg-grey">단가</td>
                                                                    <td v-if="discountEnabled" class="bg-grey">할인단가</td>
                                                                    <td class="bg-grey">일수</td>
                                                                    <td class="bg-grey">합계</td>
                                                                    <td class="bg-grey">비고</td>
                                                                </tr>
                                                                <tr v-for="(artificer, index) in portfolio.estimate.data2.laborCosts.artificers" :key="index">
                                                                    <td :colspan="discountEnabled ? 9 : 8">
                                                                        <table>
                                                                            <tbody>
                                                                                <tr v-for="(row, index) in artificer.rows" :key="index">
                                                                                    <th :rowspan="artificer.rows.length" :style="{ display: index ? 'none' : 'init' }">{{ artificer.name }}</th>
                                                                                    <td>{{ row.grade }}</td>
                                                                                    <td>{{ row.personnel }}</td>
                                                                                    <td>{{ row.name }}</td>
                                                                                    <td>{{ row.unitPrice ? (+row.unitPrice).format() : '' }}</td>
                                                                                    <td v-if="discountEnabled">{{ row.discountPrice ? (+row.discountPrice).format() : '' }}</td>
                                                                                    <td>{{ row.days ? (+row.days).format() : '' }}</td>
                                                                                    <td v-if="!discountEnabled">{{ row.amount ? (+row.amount).format() : '' }}</td>
                                                                                    <td v-else>{{ row.discountAmount ? (+row.discountAmount).format() : '' }}</td>
                                                                                    <td>{{ row.remark }}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th colspan="2" class="bg">소계</th>
                                                                    <td :colspan="discountEnabled ? 5 : 4" class="bg-light"></td>
                                                                    <td colspan="3" class="bg-light">
                                                                        <div><b>공급가격: {{ laborCosts.supplyAmount.format() }} 원</b></div>
                                                                        <div v-if="discountEnabled"><b>할인가격: {{ laborCosts.discountAmount.format() }} 원 ({{ 100 - Math.floor(laborCosts.discountAmount / laborCosts.supplyAmount * 100) || 0 }}%)</b></div>
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <br>
                                            <div class="estimate-table estimate-table--bottom">
                                                <div class="tr">
                                                    <div class="th">공급가</div>
                                                    <div class="td">{{ supplyAmount.format() }} 원</div>
                                                </div>
                                                <div v-if="portfolio.estimate.vatEnable" class="tr">
                                                    <div class="th">부가세</div>
                                                    <div class="td">{{ vat.format() }} 원</div>
                                                </div>
                                                <div class="tr">
                                                    <div class="th">컨설팅</div>
                                                    <div class="td">{{ consulting.format() }} 원</div>
                                                </div>
                                                <div class="tr">
                                                    <div class="th"><b>총금액</b></div>
                                                    <div class="td">
                                                        <div><b>공급가격: {{ totalSupplyAmount.format() }} 원</b></div>
                                                        <div v-if="discountEnabled"><b>할인가격: {{ totalDiscountAmount.format() }} 원 ({{ 100 - Math.floor(totalDiscountAmount / totalSupplyAmount * 100) || 0 }}%)</b></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </li>
                                    <!-- <tab-contents
                                        :key="currentId"
                                        currentId/> -->
                                    </transition>
                                </ul>
                            </section>
                            <section class="estimate-section" v-if="portfolio.estimate.type == 'file'">
                                <h2 class="title">견적정보</h2>

                                <img :src="portfolio.estimate.file">
                            </section>
                        </div>
                    </div>
                    <div class="modal__foot modal__foot-no-border">
                        <div class="modal__buttons modal__buttons--narrow">
                            <a class="button button--border-primary" href="" onclick="return false;" @click="modal = false;"><span>확인</span></a>
                            <!-- <a class="button button--primary" href="/mypage/cart"><span>장바구니 가기</span></a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TabItem from "./tab-item.vue";
export default {
    components:{
        TabItem
    },
    props: {
        portfolio : {type : Object, default : null}
    },
    data() {
        return {
            modal : false,
            currentId: 1,
            list: [
                { id: 1, label: '기본견적' },
                { id: 2, label: '상세견적' }
            ]
        }
    },
    computed: {
        discountEnabled(){
            return !this.portfolio.estimate.discountType || this.portfolio.estimate.discountType == "none" ? false : true;
        },
        supplyAmount(){
            switch(this.portfolio.estimate.type){
                case "data1": return this.portfolio.estimate.data1.reduce((amount, item) => { return (+item.amount || 0) + amount; }, 0);
                case "data2": return this.material.supplyAmount + this.laborCosts.supplyAmount;
            }
            return 0;
        },
        discountAmount(){
            switch(this.portfolio.estimate.type){
                case "data1": return this.portfolio.estimate.data1.reduce((amount, item) => { return (+item.discountAmount || 0) + amount; }, 0);
                case "data2": return this.material.discountAmount + this.laborCosts.discountAmount;
            }
            return 0;
        },
        vat(){
            return this.discountEnabled ? this.supplyVat : this.discountVat;
        },
        supplyVat(){
            switch(this.portfolio.estimate.type){
                case "data1": return this.supplyAmount * 0.1;
                case "data2": return ( +this.supplyAmount + this.supplyConsulting) * 0.1;
            }
            return 0;
        },
        discountVat(){
            switch(this.portfolio.estimate.type){
                case "data1": return this.discountAmount * 0.1;
                case "data2": return ( +this.discountAmount + this.discountConsulting) * 0.1;
            }
            return 0;
        },
        material(){
            return {
                supplyAmount: this.portfolio.estimate.data2.material.spaces.reduce((amount, space) => {
                    return +space.rows.reduce((amount, row) => { return (+row.amount || 0) + amount; }, 0) + amount;
                }, 0),
                discountAmount: this.portfolio.estimate.data2.material.spaces.reduce((amount, space) => {
                    return +space.rows.reduce((amount, row) => { return (+row.discountAmount || 0) + amount; }, 0) + amount;
                }, 0)
            }
        },
        laborCosts(){
            return {
                supplyAmount: this.portfolio.estimate.data2.laborCosts.artificers.reduce((amount, artificer) => {
                    return +artificer.rows.reduce((amount, row) => { return (+row.amount || 0) + amount; }, 0)  + amount;
                }, 0),
                discountAmount: this.portfolio.estimate.data2.laborCosts.artificers.reduce((amount, artificer) => {
                    return +artificer.rows.reduce((amount, row) => { return (+row.discountAmount || 0) + amount; }, 0)  + amount;
                }, 0)
            };
        },
        consulting(){
            return this.discountEnabled ? this.supplyConsulting : this.discountConsulting;
        },
        supplyConsulting(){
            return this.supplyAmount * (this.portfolio.estimate.consultingRate || 0) / 100;
        },
        discountConsulting(){
            return this.discountAmount * (this.portfolio.estimate.consultingRate || 0) / 100;
        },
        totalAmount(){
            return this.discountEnabled ? this.totalSupplyAmount : this.totalDiscountAmount;
        },
        totalSupplyAmount(){
            switch(this.portfolio.estimate.type){
                case "data1": return this.portfolio.estimate.vatEnable ? this.supplyAmount + this.supplyVat : this.supplyAmount;
                case "data2": return this.portfolio.estimate.vatEnable ? +this.supplyAmount + this.supplyConsulting + this.supplyVat : +this.supplyAmount + this.supplyConsulting;
            }
            return 0;
        },
        totalDiscountAmount(){
            switch(this.portfolio.estimate.type){
                case "data1": return this.portfolio.estimate.vatEnable ? this.discountAmount + this.discountVat : this.discountAmount;
                case "data2": return this.portfolio.estimate.vatEnable ? +this.discountAmount + this.discountConsulting + this.discountVat : +this.discountAmount + this.discountConsulting;
            }
            return 0;
        }
    }
}
</script>

<style lang="scss" scoped>
/* 트랜지션 전용 스타일 */
// .v-leave-active {
//   position: absolute;
// }
// .v-enter {
//   transform: translateX(-100%);
// }
// .v-leave-to {
//   transform: translateX(100%);
// }


/* 모달 견적서 스타일 */
.estimate-container{
    .tab-list > li { width: auto; }
    ::v-deep .tab-list > li .button { padding: 13px 8px; min-width: 98px; height: auto; font-size: 16px; }
}
.estimate-section:not(:last-child) { margin: 0 0 40px; }
.estimate-section .title { display: block; margin: 0 0 20px; line-height: 1; font-size: 18px; color: #30cd84; font-weight: 500; }

.estimate-table { display: table; width: 100%; border-top: 1px solid #30cd84; }
.estimate-table .tr { display: table-row; }
.estimate-table .th { display: table-cell; vertical-align: middle; padding: 12px 20px; width: 18.1%; text-align: center; font-size: 16px; font-weight: 500; color: #000; border-bottom: 1px solid #ffffff; background-color: rgba(48,205,132,.1); }
.estimate-table .td { display: table-cell; vertical-align: top; padding: 12px 20px; width: 32%; font-size: 16px; font-weight: 300; color: #999999; border-bottom: 1px solid #f6f6f6; }
.estimate-table .th b,
.estimate-table .td b { font-weight: 700; }
.estimate-table--vertical .th { padding: 12px 4px; width: auto; text-align: center; }
.estimate-table--vertical .td { padding: 12px 4px; width: auto; text-align: center; }
.estimate-table--vertical .th:not(:last-child) { border-right: 1px solid #ffffff; }
.estimate-table--vertical .td:not(:last-child) { border-right: 1px solid #f6f6f6; }
.estimate-table--vertical .td:last-child { padding-right: 30px; text-align: right; }
.estimate-table--horizontal .tr:last-child .th,
.estimate-table--horizontal .tr:last-child .td,
.estimate-table--bottom { border-top: none; }
.estimate-table--bottom .tr:last-child .th,
.estimate-table--bottom .tr:last-child .td { border-bottom-color: #ffffff; }
.estimate-table--bottom .th { font-weight: 300; color: #ffffff; background-color: #30cd84; }
.estimate-table--bottom .td { padding-right: 30px; width: 82%; text-align: right; font-size: 18px; font-weight: 300; color: #555555; background-color: rgba(48,205,132,.1); }
.estimate-table--bottom .tr:not(:last-child) .td { border-bottom: 1px solid #ffffff; }
@media(max-width:1024px){
    .estimate-container{
        ::v-deep .tab-list > li .button {padding: 9px 8px; font-size: 14px; }
    }

	.estimate-section .title { margin: 0 0 16px; font-size: 16px; }

	.estimate-table .th { padding: 10px 18px; min-height: 40px; font-size: 13px; }
	.estimate-table .td { padding: 10px 18px; min-height: 40px; font-size: 13px; }
}
@media(max-width:768px){
	.estimate-table--horizontal { display: block; }
	.estimate-table--horizontal .tr,
	.estimate-table--bottom .tr { display: grid; grid-template-columns: 130px auto; }
	.estimate-table--horizontal .th,
	.estimate-table--bottom .th { display: inline-flex; align-items: center; justify-content: center; padding: 10px 4px; width: auto; }
	.estimate-table--horizontal .td,
	.estimate-table--bottom .td { display: inline-flex; align-items: center; padding: 10px 16px; width: auto; overflow-wrap: anywhere; }
	.estimate-table--vertical .td:last-child { padding-right: 16px; }
}


.etable-border { display: block; border-top: 1px solid #30cd84; }
.etable { table-layout: fixed; border-collapse: collapse; width: 100%; text-align: center; font-size: 16px; font-weight: 400; color: #999999; }
.etable .bg { color: #555555; font-weight: 700; background: #e6e6e6; }
.etable .bg-light { color: #333333; background-color: #f9f9f9; }
.etable .bg-grey { color: #333333; background-color: #f9f9f9; border-right: 1px solid #ffffff; }
.etable tr th { padding: 14px 4px; width: 100px; height: 52px; font-weight: 500; color: #333333; background-color: rgba(48,205,132,.1); border-bottom: 1px solid #ffffff; }
.etable tr th:first-child { border-right: 1px solid #ffffff; }
.etable tr td { border-bottom: 1px solid #ffffff; }
.etable table { table-layout: fixed; width: 100%; }
.etable table tr td { border-right: 1px solid #f5f5f5; border-bottom: 1px solid #f6f6f6; }
.etable tfoot tr th { border-right: none !important; }
.etable tfoot tr td:last-child { padding-right: 30px; text-align: right; font-size: 18px; color: #333333; }
@media(max-width:1200px){
	.etable { font-size: 13px; }
    .etable tr th[data-v-e7844046] { width: 80px; }
    .etable tfoot tr td:last-child { font-size: 13px; }
}
@media(max-width:768px){

}
</style>
